export default function focusOnFirstFormInputWithErrorNative(form) {
	if (!form) return
	const FOCUSABLE_ELEMENTS_SELECTOR =
		'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'

	const elementWithErrors = form.querySelectorAll('.has-error')
	const elementWithErrorsCount = elementWithErrors.length

	let foundElementToFocus = null

	for (let i = 0; i < elementWithErrorsCount; i++) {
		const focusable = elementWithErrors[i].querySelector(FOCUSABLE_ELEMENTS_SELECTOR)
		if (focusable) {
			foundElementToFocus = focusable
			break
		}
	}

	if (!foundElementToFocus) return
	foundElementToFocus.focus()
}
